// API Configuration
// Centralized configuration for API endpoints

const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL || "https://akivjbdpfwdenlnifwao.supabase.co";
const SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFraXZqYmRwZndkZW5sbmlmd2FvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY3MDc3MjcsImV4cCI6MjA2MjI4MzcyN30.Oun5tljvc-iBmatUT4sbrgVgJn570zK-xuNgm52MWuI";
const MAX_RECORDING_TIME_SECONDS = parseInt(
  import.meta.env.VITE_MAX_RECORDING_TIME_SECONDS || "180",
  10
);

export const API_CONFIG = {
  // Supabase project configuration
  SUPABASE_URL: SUPABASE_URL,
  SUPABASE_ANON_KEY: SUPABASE_ANON_KEY,

  // Supabase Edge Functions
  CHAT_API_URL: `${SUPABASE_URL}/functions/v1/chat`,
  MEMORY_API_URL: `${SUPABASE_URL}/functions/v1/update-tutor-memory`,
  ANALYSIS_API_URL: `${SUPABASE_URL}/functions/v1/analyze-conversation`,
  CHAT_MINDMAP_API_URL: `${SUPABASE_URL}/functions/v1/chat-mindmap`,
  SPEECH_TO_TEXT_API_URL: `${SUPABASE_URL}/functions/v1/speech-to-text`,
  TEXT_TO_SPEECH_STREAM_API_URL: `${SUPABASE_URL}/functions/v1/text-to-speech-stream`,
  CACHE_MESSAGE_AUDIO_API_URL: `${SUPABASE_URL}/functions/v1/cache-message-audio`,
  CREATE_STUDENT_CREDENTIALS_API_URL: `${SUPABASE_URL}/functions/v1/create-student-credentials`,
  UPDATE_STUDENT_PASSWORD_API_URL: `${SUPABASE_URL}/functions/v1/update-student-password`,
  INVITE_TEACHER_API_URL: `${SUPABASE_URL}/functions/v1/invite-teacher`,
  BULK_INVITE_TEACHERS_API_URL: `${SUPABASE_URL}/functions/v1/bulk-invite-teachers`,
  COMPLETE_TEACHER_REGISTRATION_API_URL: `${SUPABASE_URL}/functions/v1/complete-teacher-registration`,
  SUMMARIZE_CONVERSATION_API_URL: `${SUPABASE_URL}/functions/v1/summarize-conversation`,
  ADMIN_UPDATE_USER_PASSWORD_API_URL: `${SUPABASE_URL}/functions/v1/admin-update-user-password`,
  CREATE_CLASS_STUDENTS_API_URL: `${SUPABASE_URL}/functions/v1/create-class-students`,
  IMPERSONATE_DEMO_API_URL: `${SUPABASE_URL}/functions/v1/impersonate-demo`,

  // Supabase Storage endpoints
  STORAGE_BASE_URL: `${SUPABASE_URL}/storage/v1/object/public`,
  TUTOR_AVATARS_STORAGE_URL: `${SUPABASE_URL}/storage/v1/object/public/tutor-avatars`,
  TEMPORARY_STUDENT_AVATARS_STORAGE_URL: `${SUPABASE_URL}/storage/v1/object/public/temporary-student-avatars`,
  CHAT_IMAGES_STORAGE_URL: `${SUPABASE_URL}/storage/v1/object/public/chat-images`,

  // Recording configuration
  MAX_RECORDING_TIME_SECONDS: MAX_RECORDING_TIME_SECONDS,
} as const;

// Environment detection
export const IS_DEVELOPMENT =
  import.meta.env.VITE_ENVIRONMENT === "development" ||
  (typeof window !== "undefined" && window.location.hostname === "localhost");
export const IS_PRODUCTION = !IS_DEVELOPMENT;
